import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Check, Loader2, Settings2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const LABELS = { section_types: 'Section types', industries: 'Industries', use_cases: 'Use cases' };

/** Admin: one textarea per pick-list, a value per line. */
export const TaxonomyDialog = ({ open, onOpenChange, taxonomy, onSaved }) => {
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setForm(Object.fromEntries(Object.keys(LABELS).map((k) => [k, (taxonomy[k] || []).join('\n')]))); }, [open, taxonomy]);
  const save = async () => {
    setBusy(true);
    try {
      const body = Object.fromEntries(Object.keys(LABELS).map((k) => [k, form[k].split('\n').map((s) => s.trim()).filter(Boolean)]));
      const r = await axios.put(`${API_URL}/api/rfp/narrative-library/taxonomy`, body, { withCredentials: true });
      toast.success('Pick-lists updated'); onSaved(r.data);
    } catch (err) { toast.error(err?.response?.data?.detail || 'Could not save'); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl" data-testid="nlib-taxonomy-dialog">
        <DialogHeader><DialogTitle className="text-sm flex items-center gap-2"><Settings2 className="w-4 h-4 text-[#4ABFCF]" />Narrative Library pick-lists</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Everyone classifies blocks from these lists. One value per line; renaming a value does not re-tag existing blocks.</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {Object.entries(LABELS).map(([k, label]) => (
            <label key={k} className="text-xs text-slate-600 space-y-1"><span className="font-semibold text-[#0F2040]">{label}</span>
              <textarea value={form[k] || ''} onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))} rows={12} className="w-full p-2 text-xs border border-slate-200 rounded font-mono resize-y" data-testid={`nlib-taxonomy-${k}`} />
            </label>
          ))}
        </div>
        <div className="flex justify-end gap-2">
          <Button size="sm" variant="outline" className="h-8 text-xs" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button size="sm" className="h-8 text-xs bg-[#0F2040] text-white" onClick={save} disabled={busy} data-testid="nlib-taxonomy-save">{busy ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <Check className="w-3.5 h-3.5 mr-1" />}Save</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
